import { useTranslation } from 'react-i18next';

type FakeDoorConfig = {
    title: string;
    description: string;
    button: string;
};

const fakeDoors: Record<string, FakeDoorConfig> = {
    nutrition: {
        title: 'fakeDoor.nutrition.title',
        description: 'fakeDoor.nutrition.description',
        button: 'fakeDoor.nutrition.button',
    },
    fitness: {
        title: 'Fitness Feature',
        description: 'This is a fake door for the fitness feature.',
        button: 'Learn More',
    },
};

export const useFakeDoor = (id: string | undefined) => {
    const { t } = useTranslation();

    if (!id) {
        return undefined;
    }

    const config = fakeDoors[id];

    if (!config) {
        return undefined;
    }

    return {
        title: t(config.title),
        description: t(config.description),
        button: t(config.button),
    };
};
